<h2 mat-dialog-title style="font-size: x-large;">{{'D_T1' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <div *ngIf="data.feedback">
        <h3 style="font-size: large;" 
        *ngIf="!data.percentage">{{'MP_P20' | translate}} {{data.correctAnswersCount}} {{'MP_P21' | translate}} {{data.totalAnswersCount}}
            {{'D_P1' | translate}} {{data.avgResponseTime}} ms.
        </h3>
        <h3 style="font-size: large;" 
        *ngIf="data.percentage">
            {{data.percentage}}% {{'D_P8' | translate}}
        </h3>
    </div>
    <h3 style="font-size: large;">{{'D_P2' | translate}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button style="font-size: large;" mat-button mat-dialog-close>{{'D_B1' | translate}}</button>
</mat-dialog-actions>
